import classNames from 'classnames';

export default function ContentTemplate({
  children,
  Header,
  disableFlex = false,
  className
}) {
  return (
    <div
      id="content-template"
      className={classNames(
        className,
        'relative',
        'space-y-10 my-20 min-h-full pb-16',
        {
          'flex flex-col items-center justify-center': !disableFlex,
        },
      )}
    >
      {Header && Header}
      {children}
    </div>
  );
}
